import { proxy } from "valtio";

type StoreType = {
    defaultSetting: any;
    isPaymentModified: boolean;
    isSaleModeModified: boolean;
    isSaleSupportModified: boolean;
    saleMode: any;
    paymentMethod: any;
    isLoading: boolean;
};

export const store = proxy<StoreType>({
    defaultSetting: {
        tva: {},
        language: {},
        saleSupport: {},
        saleMode: {},
        paymentMethod: {},
        currency: {},
        applications: {},
        peripheral: {},
    },
    isPaymentModified: false,
    isSaleModeModified: false,
    isSaleSupportModified: false,
    saleMode: [],
    paymentMethod: [],
    isLoading: false,
});
export function setDefaultSetting(defaultSetting: any): void {
    store.defaultSetting = defaultSetting;
}
export function setIsPaymentModified(): void {
    store.isPaymentModified = !store.isPaymentModified;
}
export function setIsSaleModeModified(): void {
    store.isSaleModeModified = !store.isSaleModeModified;
}
export function setSaleMode(sale: any): void {
    store.saleMode = sale;
}
export function setPayment(payment: any): void {
    store.paymentMethod = payment;
}
export function setIsSaleSupportModified(isSaleSupportModified: boolean): void {
    store.isSaleSupportModified = isSaleSupportModified;
}
export function setIsLoading(isLoading: boolean): void {
    store.isLoading = isLoading;
}

export default store;
